import { render } from "./tydefp.vue?vue&type=template&id=67f2df78&scoped=true"
import script from "./tydefp.vue?vue&type=script&lang=js"
export * from "./tydefp.vue?vue&type=script&lang=js"

import "./tydefp.vue?vue&type=style&index=0&id=67f2df78&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f2df78"]])

export default __exports__